import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import putData from "../services/putData";

const handleFetchSites = async () => {
  const uri = `v1/sites`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateSite = async (data: any) => {
  const uri = `v1/sites`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateSite = async ({ data, _id }: any) => {
  const uri = `v1/sites/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleCountSites = async ({ data, _id }: any) => {
  const uri = `v1/sites/count/all`;
  const response = putData({ data, uri });
  return response;
};

const handleExportSites = async ({ data, _id }: any) => {
  const uri = `v1/sites/export/all`;
  const response = putData({ data, uri });
  return response;
};

const handleDeleteSite = async ({ _id }: any) => {
  const uri = `v1/sites/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchSites,
  handleCreateSite,
  handleUpdateSite,
  handleDeleteSite,
  handleCountSites,
  handleExportSites,
};
